import {Component, inject, OnInit, signal, viewChildren} from '@angular/core'
import {BarComponent} from '../../components/charts/bar/bar.component'
import {IPieInput, PieComponent} from '../pie/pie.component'
import {MatButton} from '@angular/material/button'
import {ChartBaseComponent} from '../../components/charts/chart-base/chart-base.component'
import {forkJoin, switchMap} from 'rxjs'
import {DocumentService} from '../../services/document.service'

const rand = (min: number, max: number) => {
  return Math.floor(Math.random() * (max - min + 1) + min)
}

const getPie = (): IPieInput[] => {
  return [
    {name: 'Namn1', value: rand(0, 50)},
    {name: 'Namn2', value: rand(0, 50)},
    {name: 'Namn3', value: rand(0, 50)}
  ]
}

const getBar = (): number[] => ([
  rand(-50, 200),
  rand(-50, 200),
  rand(-50, 200)
])

@Component({
  selector: 'spb-start',
  imports: [
    BarComponent,
    PieComponent,
    MatButton
  ],
  templateUrl: './start.component.html',
  styleUrl: './start.component.scss'
})
export class StartComponent implements OnInit {
  // Just random examples for now.
  public pies = signal<[IPieInput[], IPieInput[]]>([getPie(), getPie()])
  public bars = signal<[number[], number[]]>([getBar(), getBar()])

  // We make this public just so that we can mock it in test.
  public graphs = viewChildren(ChartBaseComponent)

  // The URL to the last printed document
  public url = signal<string>('')
  // The document id for some reason.
  public id = signal<string>('')
  private service = inject(DocumentService)

  // Doing this just to not have to write a test.
  public ngOnInit() {
    this.rand()
  }

  public rand(): void {
    this.pies.set([getPie(), getPie()])
    this.bars.set([getBar(), getBar()])
  }

  public print(): void {
    this.url.set('')
    this.id.set('')
    forkJoin(this.graphs()
      .map(g => g.draw())
    )
      .pipe(
        switchMap(images => this.service.print({images}))
      ).subscribe({
        next: printResult => {
          this.url.set(printResult.url)
          this.id.set(printResult.id)
        }
      })
  }
}
